import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  useTheme,
} from "@mui/material";
import { ref, update } from "firebase/database";
import { db } from "../../firebase"; // Adjust path based on your Firebase setup
import Notification from "../Notification";

function EditUserModal({ open, user, onClose, onSave }) {
  const [formValues, setFormValues] = useState({
    email: "",
    identifier: "",
    isAdmin: false,
  });
  const theme = useTheme();

  useEffect(() => {
    if (user) {
      setFormValues({
        email: user.Email || "",
        identifier: user.Identifier || "",
        isAdmin: user.isAdmin || false,
      });
    }
  }, [user]);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSave = async () => {
    if (!formValues.email || !formValues.identifier) {
      Notification.error(
        theme,
        "Error!",
        "Email and Identifier are required fields.",
      );
      return;
    }

    try {
      const userRef = ref(db, `users/${user.uid}`);
      await update(userRef, {
        Email: formValues.email,
        Identifier: formValues.identifier,
        isAdmin: formValues.isAdmin,
      });
      Notification.success(theme, "Success!", "User updated successfully.");
      onSave();
      onClose();
    } catch (error) {
      console.error("Error updating user:", error);
      Notification.error(
        theme,
        "Error!",
        "There was an issue updating the user.",
      );
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        }}
      >
        Edit User
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          padding: theme.spacing(3),
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
          }}
        >
          <TextField
            label="Email"
            name="email"
            value={formValues.email}
            onChange={handleChange}
            fullWidth
            sx={{ backgroundColor: theme.palette.background.paper }}
          />
          <TextField
            label="Identifier (Name)"
            name="identifier"
            value={formValues.identifier}
            onChange={handleChange}
            fullWidth
            sx={{ backgroundColor: theme.palette.background.paper }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formValues.isAdmin}
                onChange={handleChange}
                name="isAdmin"
                color="primary"
              />
            }
            label="Admin"
          />
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          padding: theme.spacing(2),
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditUserModal;
